const teamColorMapping: Record<string, string[]> = {
  "#2D8DFF": ["Blå"],
  "#616161": ["Svart"],
  "#43DDC1": [],
  "#93DFFF": ["Blå"],
  "#77CA8A": ["Grön"],
  "#ADE0C8": ["Grön"],
  "#BCEF88": ["Grön"],
  "#C0CEFF": ["Lila"],
  "#CD7CFF": ["Lila"],
  "#D1D1D1": ["Grå"],
  "#E8C289": [],
  "#F89EEF": ["Rosa"],
  "#FF9999": ["Röd"],
  "#FF9E58": ["Orange"],
  "#FFDB5A": ["Gul"],
  "#ACC6D2": [],
};

export const teamColors = Object.keys(teamColorMapping);

const matchColorTags =
  (teamName: string) => (color: { color: string; tags: string[] }) =>
    color.tags.filter((tag) => teamName.includes(tag)).length > 0;

export function getTeamColorMatches(teamName: string, usedColors: string[]) {
  const unusedColors = teamColors
    .filter((color) => !usedColors.includes(color))
    .map((color) => ({
      color,
      tags: teamColorMapping[color],
    }));
  const matching = unusedColors.filter(matchColorTags(teamName));

  return matching.map((color) => color.color);
}
